export const LOGGED_IN = 'LOGGED_IN';
export const LOG_OUT = 'LOG_OUT';
export const APP_NAME = 'ELECNOR REGISTRO DE PARTES';

export const PERFIL_ADMIN = 'ADM'
export const ROLES_EXPATRIADOS = {
	'ADMINISTRADOR':{value:'AD',label:'Administrador'}, 
	'ADMINISTRADOR_LOCAL':{value:'ADL',label:'Administrador Local'}, 
	'CONSULTA':{value:'CON',label:'Consulta'}, 
	'ADMINISTRADOR_GLOBAL':{value:'*',label:'Administrador Global'}, 
}

export const FIX_SOCIEDAD_MAESTRO_ADMUSUARIOS = '00007070'

let Entornos = {
	Desarrollo: 'development',
	PreProduccion: 'pre-production',
	Produccion: 'production'
};

export const URLAPIEMPLEADOS = 'https://apis-maestro.elecnor.es:1443'
export const LOGINAPIEMPLEADOS = {'username':'elecnorApiUser','password':'BcTd2uxNSL9Hm5CT'}

/* DESARROLLO */
export let APP_URL_ROOT = '/';
export let API_ENDPOINT = 'https://localhost:44302/api'; //44357
//44302
/* DESARROLLO TIRANDO DEL API DE PRE-PRODUCCION */
if (process.env.NODE_ENV === Entornos.Desarrollo && process.env.REACT_APP_ENVIROMENT === Entornos.PreProduccion) {
	//API_ENDPOINT = `http://ipdesa-2012:8081/ElecnorCAv3/api/v1/`;
}

if (process.env.NODE_ENV === Entornos.Produccion) {
	/* PRODCUCCION */
	APP_URL_ROOT = '/';
	API_ENDPOINT = `${APP_URL_ROOT}api`;
//	API_ENDPOINT = 'http://172.24.16.171:82/api';
}